export const CONTACT_SUPPORT_STATUS = {
  UNREAD: "Unread",
  UNREPLIED: "Unreplied",
  WAITING: "Waiting",
  SOLVED: "Solved",
  INACTIVITY: "Inactivity",
};

export const CONTACT_SUPPORT_TYPE = {
  OPEN: "Open",
  CLOSED: "Closed",
};

export const TAB = {
  TAB_1: "tab-1",
  TAB_2: "tab-2",
  TAB_MY_TICKETS: "tab-my-tickets",
};

export const contactSupportStatusLabels = {
  [CONTACT_SUPPORT_STATUS.UNREAD]: "Unread",
  [CONTACT_SUPPORT_STATUS.UNREPLIED]: "Unreplied",
  [CONTACT_SUPPORT_STATUS.WAITING]: "Waiting",
  [CONTACT_SUPPORT_STATUS.SOLVED]: "Solved",
  [CONTACT_SUPPORT_STATUS.INACTIVITY]: "Inactivity",
};

export const contactSupportStatusFilters = [
  {
    value: CONTACT_SUPPORT_STATUS.UNREAD,
    label: `${CONTACT_SUPPORT_TYPE.OPEN} - ${CONTACT_SUPPORT_STATUS.UNREAD}`,
  },
  {
    value: CONTACT_SUPPORT_STATUS.UNREPLIED,
    label: `${CONTACT_SUPPORT_TYPE.OPEN} - ${CONTACT_SUPPORT_STATUS.UNREPLIED}`,
  },
  {
    value: CONTACT_SUPPORT_STATUS.WAITING,
    label: `${CONTACT_SUPPORT_TYPE.OPEN} - ${CONTACT_SUPPORT_STATUS.WAITING}`,
  },
  {
    value: CONTACT_SUPPORT_STATUS.SOLVED,
    label: `${CONTACT_SUPPORT_TYPE.CLOSED} - ${CONTACT_SUPPORT_STATUS.SOLVED}`,
  },
  {
    value: CONTACT_SUPPORT_STATUS.INACTIVITY,
    label: `${CONTACT_SUPPORT_TYPE.CLOSED} - ${CONTACT_SUPPORT_STATUS.INACTIVITY}`,
  },
];
